<template>
    <div class="uploadWrap">
        <!-- <button @click="uploadFile" v-if="!uploadSuccess">确定上传</button> -->
        <van-form @submit="uploadFile">
            <van-field
                :disabled="uploadSuccess"
                v-model="user_name"
                name="user_name"
                label="姓名"
                placeholder="请填写姓名"
                :rules="[{ required: true,message: '请填写姓名' }]"
            />
            <van-field
            :disabled="uploadSuccess"
                v-model="user_mobile"
                name="user_mobile"
                label="手机号"
                placeholder="请填写手机号"
                :rules="[{ required: true,validator: mobileValidator,  message: '请正确填写手机号' }]"
            />
        <div class="upload">
            <div class="textWrap">
                <p>请上传您的职业医师资格证进行审核，</p>
                <p>审核完成后方可观看专栏</p>
            </div>
            <van-uploader :after-read="afterRead" v-model="fileList" max-count="1" 
            :deletable="deletable">
            </van-uploader>
            <p :style="{color:uploadSuccess?'red':'#ddd'}">{{uploadSuccess?'提交成功':'点击上传'}}</p>
        </div>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" v-if="!uploadSuccess">确定上传</van-button>
            </div>
        </van-form>
        
        <!-- <van-button type="primary" size="normal">确定上传</van-button> -->
    </div>
</template>
<script>
import { Toast } from 'vant';
import {CertificatesCheck,UploadCertificates} from "@/config/interface.js"
let File=null;
export default {
    data(){
        return{
            uploadSuccess:false,
            user_name:'',
            user_mobile:'',
            deletable:true,
            fileList: [
            ]
        }
    },
    mounted(){
        this.isUploadCert();
    },
    methods:{
        mobileValidator(val){
            let reg=/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
            return reg.test(val);
        },
		//检验用户有没有上传证书
		isUploadCert(){
				const url=CertificatesCheck;
				const method='POST';
				let params={
					type:[0]
				}
				fetch(url,params,method).then((res)=>{
					if(res.code==0){
                        let columns=res.data.columns;
                        let user_certificates=res.data.user_certificates;
                        if(user_certificates.length>0){
                            user_certificates[0].status==0?this.uploadSuccess=true:'';   //status为0   代表已上传  待审核
                            this.fileList=[
                                { url:user_certificates[0].path,isImage: true }
                            ];
                        }
                        if(columns.length>0){
                            columns.forEach((item,index)=>{
                                if(item.column_name=='user_name'){
                                    this.user_name=item.content;
                                }
                                if(item.column_name=='user_mobile'){
                                    this.user_mobile=item.content;
                                }
                            })
                        }
					}else{
						
					}
				})
				
		},
        afterRead(event) {
            File=event;
            //获取并记录图片的base64编码
            var reader = new FileReader();
            reader.readAsDataURL(event.file); // 读出 base64
            reader.onloadend = function () {
                // 图片的 base64 格式, 可以直接当成 img 的 src 属性值        
                let dataURL = reader.result;//base64
                // 显示图片
                 this.fileList=[
                    { url:dataURL }
                ];

            };
        },
        //上传
        uploadFile(){
            if(File){
                const url=UploadCertificates;
                const method='POST';
                let formData=new FormData();
                formData.append('certificates[0][file]',File.file);
                formData.append('certificates[0][type]',0);
                formData.append('user_name',this.user_name);
                formData.append('user_mobile',this.user_mobile);
                fetch(url,formData,method)
                .then((res)=>{
                    if(res.code==0){
                        this.uploadSuccess=true;
                        this.deletable=false;
                        Toast({
                                message:'提交成功',
                                duration:1000
                            });
                        }
                })
            }else{
                Toast({
                    message:'请上传图片',
                    duration:1000
                });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .uploadWrap{
        width:100%;
        position: absolute;
        top: 40%;
        left: 50%;
        text-align: center;
        transform: translate(-50%,-50%);
        .upload{
            width:90%;
            margin:20px auto;
            width: 80%;
            padding:15px 20px;
            border-radius: 5px;
            background: #F4F9FC;
        }
        p{
            font-size:12px;
            color:#ddd;
            margin-top:10px;
        }
        .textWrap{
            margin-bottom:10px;
            p{
                margin:0px;
                color:#666;
                font-size:13px;
                letter-spacing: 1px;
            }
        }
        .van-uploader{
            padding: 12px 45px;
            border-radius: 3px;
            background: #fff;
            border: 1px solid #ddd;
            img{
                width:40px
            }
        }
        button{
            padding: 8px 30px;
            font-size: 14px;
            margin-top: 30px;
            background: #5a89a6;
            border: 0px;
            border-radius: 2px;
            color: #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/UploadCert.vue